/* eslint-disable no-bitwise */
import React from 'react';

import PropTypes from 'prop-types';
import { pos1Won, pos2Won, getTieDisplay } from '../../utils/postScore';
import { sportTypeIds } from '../../utils/eventConstants';
import { getTabIndex } from '../hooks/useScoreAutoAdvance';

const UTSetV2 = (props) => {
    const {
        set,
        currentSet,
        onInputChange,
        onFocus,
        attachRef,
        onKeyDown,
        sportTypeId,
    } = props;

    const { isTie, showTie } = getTieDisplay(set, currentSet, sportTypeId);

    return (
        <div className="set-column" key={set.id}>
            <div className={`input-wrapper`}>
                <span className="set-label">{`Set ${set.id + 1}`}</span>
                <input
                    type="number"
                    value={set.pos1Score}
                    min="0"
                    max="11"
                    className={`score-box ${!set.pos1Score ? 'dashed' : ''} ${pos1Won(set) ? 'won' : ''}`}
                    onChange={event => onInputChange(set, 'pos1Score', event)}
                    onFocus={() => onFocus(set)}
                    onKeyDown={event => onKeyDown(set, 'pos1Score', event)}
                    tabIndex={getTabIndex(set.id, 'pos1Score')}
                    ref={node => attachRef(set.id, 'pos1Score', node)}
                    data-testid={`post-score.set-${set.id}.pos1-score`}
                />
                <div className={`tie-value ${set.pos1TieBrk && isTie && !showTie ? 'd-block' : 'd-none'}`}>
                    {set.pos1TieBrk}
                </div>
                {showTie && (
                    <div className="ml12">
                        <span className="tie-label">{'Tiebreak'}</span>
                        <input
                            type="number"
                            value={set.pos1TieBrk}
                            maxLength="1"
                            className={`tiebreak-box ${!set.pos1TieBrk ? 'dashed' : ''}`}
                            onChange={event => onInputChange(set, 'pos1TieBrk', event, true)}
                            onFocus={() => onFocus(set)}
                            onKeyDown={event => onKeyDown(set, 'pos1TieBrk', event)}
                            tabIndex={getTabIndex(set.id, 'pos1TieBrk')}
                            ref={node => attachRef(set.id, 'pos1TieBrk', node)}
                            data-testid={`post-score.set-${set.id}.pos1-tiebreak`}
                        />
                    </div>
                )}
            </div>
            <div className={`input-wrapper`}>
                <span className="set-label">{`Set ${set.id + 1}`}</span>
                <input
                    type="number"
                    value={set.pos2Score}
                    min="0"
                    max="11"
                    className={`score-box ${!set.pos2Score ? 'dashed' : ''} ${pos2Won(set) ? 'won' : ''}`}
                    onChange={event => onInputChange(set, 'pos2Score', event)}
                    onFocus={() => onFocus(set)}
                    onKeyDown={event => onKeyDown(set, 'pos2Score', event)}
                    tabIndex={getTabIndex(set.id, 'pos2Score')}
                    ref={node => attachRef(set.id, 'pos2Score', node)}
                    data-testid={`post-score.set-${set.id}.pos2-score`}
                />
                <div className={`tie-value ${set.pos2TieBrk && isTie && !showTie ? 'd-block' : 'd-none'}`}>
                    {set.pos2TieBrk}
                </div>
                {showTie && (
                    <div className="ml12">
                        <span className="tie-label">{'Tiebreak'}</span>
                        <input
                            type="number"
                            value={set.pos2TieBrk}
                            maxLength="1"
                            className={`tiebreak-box ${!set.pos2TieBrk ? 'dashed' : ''}`}
                            onChange={event => onInputChange(set, 'pos2TieBrk', event, true)}
                            onFocus={() => onFocus(set)}
                            onKeyDown={event => onKeyDown(set, 'pos2TieBrk', event)}
                            tabIndex={getTabIndex(set.id, 'pos2TieBrk')}
                            ref={node => attachRef(set.id, 'pos2TieBrk', node)}
                            data-testid={`post-score.set-${set.id}.pos2-tiebreak`}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

UTSetV2.propTypes = {
    set: PropTypes.shape({
        id: PropTypes.number.isRequired,
        pos1Score: PropTypes.number,
        pos1TieBrk: PropTypes.number,
        pos2Score: PropTypes.number,
        pos2TieBrk: PropTypes.number,
    }).isRequired,
    currentSet: PropTypes.number,
    onInputChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    attachRef: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    sportTypeId: PropTypes.number,
};

UTSetV2.defaultProps = {
    currentSet: null,
    sportTypeId: sportTypeIds.TENNIS,
};

export default UTSetV2;
